/**
 * Ensures that a URL has a protocol (http:// or https://).
 * If it doesn't, it prepends https://.
 * Also handles empty or null values gracefully.
 */
export function ensureAbsoluteUrl(url: string | null | undefined): string {
  if (!url) return "";
  
  const trimmedUrl = url.trim();
  if (!trimmedUrl) return "";
  
  if (/^(f|ht)tps?:\/\//i.test(trimmedUrl)) {
    return trimmedUrl;
  }
  
  return `https://${trimmedUrl}`;
}

export function getProducerPublicPath(username?: string, isOrg: boolean = false) {
  if (!username) return "/produtores";
  return isOrg ? `/organizacao/${username}` : `/produtor/${username}`;
}

export function getEventPublicPath(slug: string, producerUsername?: string, isOrg: boolean = false) {
  if (!producerUsername) return `/eventos/${slug}`;
  return isOrg ? `/organizacao/${producerUsername}/eventos/${slug}` : `/produtor/${producerUsername}/eventos/${slug}`;
}

export function getEventPublicBuyPath(slug: string, producerUsername?: string, isOrg: boolean = false) {
  return `${getEventPublicPath(slug, producerUsername, isOrg)}/comprar`;
}

export function getEventSchedulePath(slug: string, producerUsername?: string, isOrg: boolean = false) {
  return `${getEventPublicPath(slug, producerUsername, isOrg)}/programacao`;
}

export function getScheduleSessionPath(eventPath: string, sessionId: string) {
  return `${eventPath.replace(/\/$/, "")}/programacao/s/${encodeURIComponent(sessionId)}`;
}

export function getLiveRedirectUrl(token: string) {
  return `${window.location.origin}/ao-vivo/${token}`;
}

export function getEventOgUrl(slug: string, producerUsername?: string) {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "https://wmuwctsmuagetcjqeboz.supabase.co";
  const params = new URLSearchParams({ slug });
  if (producerUsername) params.set("producer", producerUsername);
  return `${supabaseUrl}/functions/v1/event-og?${params.toString()}`;
}
